export enum ViewState {
  HOME = 'HOME',
  FILMMAKER_PORTFOLIO = 'FILMMAKER_PORTFOLIO',
  STUDIO_CHAT = 'STUDIO_CHAT',
  SIGNATURE_GENERATOR = 'SIGNATURE_GENERATOR',
  DEMO_REEL = 'DEMO_REEL'
}

export type Language = 'EN' | 'ES' | 'PT' | 'FR' | 'DE';

export interface Director {
  id: string;
  name: string;
  role: string;
  desc: string;
  img: string;
}

export interface PortfolioItem {
  id: number;
  title: string;
  year: string;
  duration: string;
  type: 'internal' | 'external';
  img: string;
  video?: string;
}

export enum LoadingState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export interface ChatMessage {
  id?: string;
  role: 'user' | 'assistant' | 'model';
  content: string;
  timestamp: number;
}

export interface GeneratedImage {
  url: string;
  prompt: string;
  timestamp: number;
}
